import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrigin = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 41,
	viewBox: "0 0 41 41",
	width: 41,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m20.2803 4.04004c-3.214 0-6.3557.95304-9.028 2.73862-2.67234 1.78557-4.75514 4.32344-5.98506 7.29274-1.22993 2.9693-1.55173 6.2367-.92472 9.3889.62701 3.1521 2.17467 6.0476 4.44727 8.3202 2.27261 2.2726 5.16811 3.8203 8.32031 4.4473s6.4195.3052 9.3888-.9247 5.5072-3.3128 7.2928-5.985c1.7855-2.6723 2.7386-5.8141 2.7386-9.0281-.0046-4.3083-1.7181-8.4389-4.7646-11.48542-3.0464-3.04648-7.1771-4.75999-11.4854-4.76454zm6.3359 17.27816-8.125 5.625c-.1876.1297-.407.2056-.6347.2195-.2276.0139-.4547-.0347-.6567-.1406-.2019-.1059-.3711-.265-.4891-.4602-.118-.1951-.1804-.4188-.1804-.6469v-11.25c0-.228.0624-.4517.1804-.6469.118-.1951.2872-.3542.4891-.4601.202-.1059.4291-.1545.6567-.1406.2277.0139.4471.0898.6347.2195l8.125 5.625c.1663.115.3022.2686.3961.4477s.143.3782.143.5804-.0491.4014-.143.5805c-.0939.179-.2298.3327-.3961.4477z",
		fill: "#ffd36c"
	})
});
export default SvgOrigin;
